import * as React from "react"
import { classNames } from "../../utils"
import { TLanguage } from "../../reducers/configReducers"
import IconArrowDown from "../DropdownSelect/ArrowDown"

import "./languageSelector.scss"

interface ILanguageSelectorProps {
    languageList: TLanguage[]
    selected: string
    onSelect: (value: TLanguage) => void
}

const LanguageSelector: React.FC<ILanguageSelectorProps> = props => {
    const { languageList, selected, onSelect } = props

    const [isFocus, setFocus] = React.useState(false)

    const list = {
        EN: "English",
        MY: "Bahasa",
        CH: "中文",
        ID: "Bahasa",
        TH: "Thai",
        VN: "Tiếng Việt"
    }

    const onClickHandler = (event: React.MouseEvent, lang: TLanguage) => {
        if (lang !== selected) {
            onSelect(lang)
        }
    }

    return (
        <div
            tabIndex={0}
            className={classNames({
                "app-language-selector": true,
                "app-language-selector--focused": isFocus,
            })}
            onBlur={() => setFocus(false)}
            onClick={() => setFocus(!isFocus)}
        >
            <div className="app-language-selector__arrow-down">
                <IconArrowDown color="white" />
            </div>
            {languageList
                .map((lang) => (
                    <div
                        key={lang}
                        className={classNames({
                            "language-option": true,
                            "language-option--selected": selected === lang
                        })}
                        onClick={(event) => onClickHandler(event, lang)}
                    >{list[lang]}</div>
                ))
            }
        </div >
    )
}

export default LanguageSelector
